export default __webpack_public_path__ + "static/media/facebook-white.126fa4a7.svg";